import { FC } from 'react';

import { SearchDocument } from '@cfa/pathway-fe-shared/xp';
import { Card, CardContent, Typography } from '@cfa/react-components';

import { useBrightcoveVideo } from '@/utils/document-utils';

import { BrightcovePlayer } from '@/components/BrightcovePlayer';
import GenericError from '@/components/Error/GenericError';

interface BrightcoveProps {
  document: SearchDocument;
}

const Brightcove: FC<BrightcoveProps> = ({ document }) => {
  const { url, isLoading, error } = useBrightcoveVideo(document.contentUrl);

  if (error) {
    return <GenericError />;
  }

  return (
    <div>
      <Typography className="text-grayscale-gray6! dark:text-contrast! mt-5! px-8! py-2.5! pb-6! text-left! text-[32px]/10! font-bold! md:px-0 md:text-center!">
        {document.name}
      </Typography>
      {!isLoading && url && (
        <Card
          elevation={1}
          className="animate-fade-in! my-1! md:mx-auto! md:mb-8! md:min-w-[840px]!"
        >
          <CardContent>
            <BrightcovePlayer
              className="aspect-video w-full"
              src={url}
              title={document.name ?? 'Video'}
            />
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default Brightcove;
